import { createApiCall } from 'lib/base';

const DELETE_SUBSCRIPTION_TRANSACTION = 'DELETE_SUBSCRIPTION_TRANSACTION';

// Backend blocks this for rows confirmed Production - see
// SubscriptionService.DeleteTransaction. Sandbox and any row the server
// can't positively identify as Production are deletable; admincp's own
// confirmation dialog is the safeguard for the latter.
const deleteSubscriptionTransactionApi = createApiCall<{ id: string; transactionId: string }>(
  DELETE_SUBSCRIPTION_TRANSACTION,
  ({ id, transactionId }) => ({
    endpoint: `api/admin/subscriptions/${id}/transactions/${transactionId}`,
    method: 'DELETE',
  })
);

export default deleteSubscriptionTransactionApi;
